export default {
  page_home: {
    en: 'About Us',
    fr: 'À propos',
  },
  page_members: {
    en: 'Members',
    fr: 'Membres',
  },
  page_team: {
    en: 'Team',
    fr: 'Équipe',
  },
  page_next_competition: {
    en: 'Next Competition',
    fr: 'Prochaine compétition',
  },
  page_partners: {
    en: 'Partners',
    fr: 'Partenaires',
  },
  page_publications: {
    en: 'Publications',
    fr: 'Publications',
  },
  page_join: {
    en: 'Join Us',
    fr: 'Rejoins-nous',
  },
  language: {
    en: 'Language',
    fr: 'Langue',
  },
};
